import { RecognitionException, Parser, DefaultErrorStrategy } from "antlr4ts";
import { Recognizer, Token } from "antlr4ts";
import { ProgramDeclarationContext, ProgContext } from "./parser/XLogoParser";

export class XLogoParserErrorStrategy extends DefaultErrorStrategy {
    private currentProg: string = "";
    private currProgHasError: boolean = false;

    public progsWithErrors: string[] = [];

    public sync(recognizer: Parser): void {
        //try {
        super.sync(recognizer);
        //} catch (e) {
        //    //TODO: Catching the error makes it possible to parse after an invalid token in the top rule but it makes other recoveries of antlr impossible
        //    console.log(e);
        //}
        //console.log(recognizer.state);
        //recognizer.context instanceof ProgContext
        if (recognizer.context instanceof ProgramDeclarationContext) {
            try {
                const currName = recognizer.context.Identifier();
                if (currName.text !== this.currentProg) {
                    //if (this.currentProg) {
                    //  console.log(
                    //    "New prog " +
                    //      currName.text +
                    //      ". " +
                    //      this.currentProg +
                    //      "had errors: " +
                    //      this.currProgHasError,
                    //  );
                    //}

                    this.currentProg = currName.text;
                    this.currProgHasError = false;
                }
            } catch {
                console.log("Unknown prog that has no name");
            }
        } else if (recognizer.context instanceof ProgContext) {
            if (this.currentProg) {
                //console.log("> " + this.currentProg);
                //console.log(this.currentProg + " has error:" + this.currProgHasError);
                if (this.currProgHasError) {
                    this.progsWithErrors.push(this.currentProg);
                }
            }

            this.currentProg = "";
            this.currProgHasError = false;
        }
    }

    // Using the following method could be promising for syntax error classification

    public reportError(
        /*@NotNull*/ recognizer: Parser,
        /*@NotNull*/ e: RecognitionException,
    ): void {
        super.reportError(recognizer, e);
        //console.log("error in " + this.currentProg);
    }

    public recover(recognizer: Parser, e: RecognitionException): void {
        super.recover(recognizer, e);
    }

    /*@Override*/
    public recoverInline(recognizer: Parser): any {
        let result = super.recoverInline(recognizer);
        //console.log("error in " + this.currentProg);
        return result;
    }

    protected beginErrorCondition(recognizer: Parser): void {
        super.beginErrorCondition(recognizer);
        this.currProgHasError = true;
        console.log("error in " + this.currentProg);
    }

    /*@Override*/
    public syntaxError<T extends Token>(
        /*@NotNull*/
        recognizer: Recognizer<T, any>,
        offendingSymbol: T | undefined,
        line: number,
        charPositionInLine: number,
        /*@NotNull*/
        msg: string,
        e: RecognitionException | undefined,
    ): void {
        if (recognizer instanceof Parser) {
            recognizer.context;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/xlogo-parser/xLogoParserErrorStrategy.ts